import "core-js/modules/es.array.reverse.js";
var _class, _GpxCatalogItem;
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/web.url.js";
import "core-js/modules/web.url.to-json.js";
import "core-js/modules/web.url-search-params.js";
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
import toGeoJSON from "@mapbox/togeojson";
import i18next from "i18next";
import { action, computed, makeObservable, override } from "mobx";
import getFilenameFromUri from "terriajs-cesium/Source/Core/getFilenameFromUri";
import isDefined from "../../../Core/isDefined";
import loadText from "../../../Core/loadText";
import { networkRequestError } from "../../../Core/TerriaError";
import GeoJsonMixin from "../../../ModelMixins/GeojsonMixin";
import GpxCatalogItemTraits from "../../../Traits/TraitsClasses/GpxCatalogItemTraits";
import CreateModel from "../../Definition/CreateModel";
import CommonStrata from "../../Definition/CommonStrata";
import proxyCatalogItemUrl from "../proxyCatalogItemUrl";
let GpxCatalogItem = (_class = (_GpxCatalogItem = class GpxCatalogItem extends GeoJsonMixin(CreateModel(GpxCatalogItemTraits)) {
  constructor() {
    super(...arguments);
    makeObservable(this);
  }
  get type() {
    return GpxCatalogItem.type;
  }
  get typeName() {
    return i18next.t("models.gpx.name");
  }
  setFileInput(file) {
    this.setTrait(CommonStrata.user, "url", URL.createObjectURL(file) + "#" + file.name);
  }
  get hasLocalData() {
    var _this$url$startsWith, _this$url;
    return (_this$url$startsWith = (_this$url = this.url) === null || _this$url === void 0 ? void 0 : _this$url.startsWith("blob:")) !== null && _this$url$startsWith !== void 0 ? _this$url$startsWith : false;
  }
  loadGpxText(text) {
    const dom = new DOMParser().parseFromString(text, "text/xml");
    return toGeoJSON.gpx(dom);
  }
  async forceLoadGeojsonData() {
    let data;
    if (isDefined(this.gpxString)) {
      data = this.gpxString;
    } else if (isDefined(this.url)) {
      data = await loadText(proxyCatalogItemUrl(this, this.url));
    }
    if (!data) {
      throw networkRequestError({
        sender: this,
        title: i18next.t("models.gpx.errorLoadingTitle"),
        message: i18next.t("models.gpx.errorLoadingMessage", {
          appName: this.terria.appName
        })
      });
    }
    return this.loadGpxText(data);
  }
  forceLoadMetadata() {
    return Promise.resolve();
  }
  get name() {
    if (this.url && super.name === this.url) {
      return getFilenameFromUri(this.url);
    }
    return super.name;
  }
}, _defineProperty(_GpxCatalogItem, "type", "gpx"), _GpxCatalogItem), _applyDecoratedDescriptor(_class.prototype, "setFileInput", [action], Object.getOwnPropertyDescriptor(_class.prototype, "setFileInput"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "hasLocalData", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "hasLocalData"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "name", [override], Object.getOwnPropertyDescriptor(_class.prototype, "name"), _class.prototype), _class);
export default GpxCatalogItem;